import styled from 'styled-components';

const StyledContainer = styled.div`
	width: 100%;
	height: 60px;
	min-height: 60px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0 20px;
	background-color: rgba(255, 255, 255, 0.02);
	border-radius: 10px;
`;

const StyledLeftContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2px;
	color: #ffffff;
`;

const StyledRightContainer = styled.div`
	display: flex;
	gap: 20px;
	align-items: center;
`;

const StyledIcon = styled.div`
	width: 20px;
	height: 20px;
	cursor: pointer;
	opacity: 0.5;
	transition: opacity 0.3s ease;

	&:hover {
		opacity: 1;
	}

	img {
		width: 20px;
		height: 20px;
		user-select: none;
		pointer-events: none;
	}
`;

export {
	StyledContainer,
	StyledIcon,
	StyledLeftContainer,
	StyledRightContainer,
};
